import React from 'react';
import PropTypes from 'prop-types';

export default class ReduxLegacyContextBridge extends React.PureComponent {
  static childContextTypes = {
    store: PropTypes.object.isRequired,
  };

  getChildContext() {
    return {
      store: this.props.store,
    };
  }

  render() {
    return this.props.children;
  }
}

ReduxLegacyContextBridge.propTypes = {
  children: PropTypes.node.isRequired,
  store: PropTypes.object.isRequired,
};
